export default __webpack_public_path__ + "static/paypal-complete-transaction-as-guest-v4-04f9389c2d7b6bc44fc2e7cc37771dbe.jpg";